import { render, staticRenderFns } from "./OnboardingCompany.vue?vue&type=template&id=7a1d97bf&"
import script from "./OnboardingCompany.vue?vue&type=script&lang=js&"
export * from "./OnboardingCompany.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports